import React from "react";
import SplitThePotHowItWorks from './SplitThePotHowItWorks';
import PrizeOnlyDrawHowItWorks from './PrizeOnlyDrawHowItWorks';
import ChaseTheAceHowItWorks from './ChaseTheAceHowItWorks';

function MainHowItWorks(props) {
  const { event, language, settings } = props;
  return (
    <div className="main-how-it-works bg-secondary text-secondary-contrast py-6">
      {event.game.id === 1 && (<SplitThePotHowItWorks event={event} />)}
      {event.game.id === 2 && (<PrizeOnlyDrawHowItWorks event={event} />)}
      {event.game.id === 3 && (
        <ChaseTheAceHowItWorks
          event={event}
          language={language}
          step1_logo={settings.step1_logo}
          step2_logo={settings.step2_logo}
          step3_logo={settings.step3_logo}
          step4_logo={settings.step4_logo}
          step5_logo={settings.step5_logo}
        />
      )}
      {event.is_active && event.web_enabled && +event.shopify_enabled !== 1 && (
        <div className="flex justify-center">
          <span
            to="/select-tickets"
            className="cursor-pointer w-auto no-underline bg-accent hover:bg-accent-dark text-primary font-bold text-xl py-4 px-6 rounded mt-8 shadow-outline"
          >
            BUY NOW
        </span>
        </div>
      )}
    </div>
  );
}

export default MainHowItWorks;
